import React, { useCallback } from 'react';

import { LoginSocialGoogle } from 'reactjs-social-login';
import { useCookies } from 'react-cookie';
import { HOST_URL } from '../../../actions/api';
import { GOOGLE_CLIENT_ID } from '../../../actions/constant';

const REDIRECT_URI = `${HOST_URL}/feeds/authCallback`
const SocialGoogleLogin = (props) => {
    const [cookies, setCookie] = useCookies([`ugcAuthorisedName${localStorage.getItem("networkId")}`]);
    const [cookiesAv, setCookieAv] = useCookies([`ugcAuthorisedAvatar${localStorage.getItem("networkId")}`]);

    const onLoginStart = useCallback(() => {
    }, []);

    return (
        <>
            <LoginSocialGoogle
                client_id={GOOGLE_CLIENT_ID}
                onLoginStart={onLoginStart}
                redirect_uri={REDIRECT_URI}
                scope="openid profile email"
                discoveryDocs="claims_supported"
                access_type="offline"
                onResolve={({ provider, data }) => {
                    const name = data.name;
                    const avatar = data.picture;
                    if (!props.socialLogin) {
                        setCookie(`ugcAuthorisedName${localStorage.getItem("networkId")}`, name, { path: '/' });
                        setCookieAv(`ugcAuthorisedAvatar${localStorage.getItem("networkId")}`, avatar, { path: '/' });
                        props.onUpdateData(name, avatar);
                    } else {
                        props.onUpdateData(provider, data);
                    }

                }}
                onReject={err => {
                    console.log(err);
                }}
            >
                {props.children}
            </LoginSocialGoogle>
        </>
    );
};

export default SocialGoogleLogin;